@if (showPageSpinner) {
  <div class="app-loader">
    <div class="u-flex-center">
      <mat-spinner color="primary" diameter="50"></mat-spinner>
    </div>
  </div>
}

@if (!showPageSpinner) {
  <app-page-header hideDebitStatus="true" extraClass="full-height {{ isDesktopLayout ? 'hidden' : '' }}"
  headerImage="{{ headerImage }}" imageSrc="{{ logoImage }}" imageAlt="BDDC Logo"></app-page-header>
  <div class="login-form_wrapper cr" [style.background-image]="isDesktopLayout ? 'url(' + headerImage + ')' : ''">
    @if (isDesktopLayout) {
      <img img src="{{ logoImage }}" alt="BDDC Logo" />
    }
    <div class="login-form {{ loginErrorMessage ? 'form-has-error' : '' }}">
      <h1 class="mat-headline-3">Pawtal Login</h1>
      <div class="mat-body-medium login-form_error {{
          loginErrorMessage ? 'show-error' : ''
        }}">
        {{ loginErrorMessage }}
      </div>
      <div class="login-form_wrapper">
        <form [formGroup]="form" (ngSubmit)="logUserIn(form.value)">
          <mat-form-field matInput appearance="outline" hideRequiredMarker="true" floatLabel="always" class="login-form_input login-form-field">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" placeholder="example@email.co.uk" (blur)="onBlurMethod()" required
              autocomplete="email" />
          </mat-form-field>
          <mat-form-field matInput appearance="outline" hideRequiredMarker="true" floatLabel="always" class="login-form_input login-form-field">
            <mat-label>Password</mat-label>
            <input matInput type="{{ showPasswordValue ? 'text' : 'password' }}" formControlName="password"
              placeholder="Password" (blur)="onBlurMethod()" required />
            <mat-icon matTextSuffix (click)="showPassword()" class="login-form_password-icon" color="primary">remove_red_eye
            </mat-icon>
          </mat-form-field>
          <div class="login-form_buttons {{
              loginErrorMessage ? 'form-has-error' : ''
            }}">
            <!-- <mat-checkbox (click)="rememberMe()" color="primary">Remember me</mat-checkbox> -->
            <a mat-button (click)="goToforgotPassword()" class="login-form-link">
              Forgot Password?
            </a>
          </div>
          <div class="login-form_buttons is-centered {{
              loginErrorMessage ? 'form-has-error' : ''
            }}">
            <button mat-raised-button color="primary" class="rounded">
              Login
            </button>
          </div>
          @if (isMobile()) {
            <div class="u-text-center">
              <h1 class="mat-headline-3 u-margin-bottom-15">Get your paws on our app!</h1>
              <p class="mat-body-medium u-text-center margin-bottom_30">For the best experience download our app today and
                bring your
                dog's day to life!
              </p>
              <app-download-app-buttons></app-download-app-buttons>
            </div>
          }
        </form>
      </div>
    </div>
    <div class="mat-body-medium copy-right-text">
      &copy; Bruce's {{ year }} |
      <span class="mat-body-medium copy-right-text_link" (click)="goToCookies()">Use of cookies</span>
    </div>
  </div>
  @if (isLoading) {
    <div class="app-loader">
      <div class="u-flex-center">
        <mat-spinner color="primary" diameter="50"></mat-spinner>
      </div>
    </div>
  }
}